<section
  class="min-h-screen flex flex-col items-center justify-center text-center px-6">
  <p i18n="@@expired-preview.message" class="text-xl text-gray-700 mb-6">
    Preview expired – click Preview again in the editor.
  </p>
</section>
